import { Link } from "react-router-dom";
import { articles, type Article } from "../../../mocks/articles";

type Column = { key: string; name: string; icon: string; desc: string; color: string };

const colList: Column[] = [
  { key: "headline", name: "头条解读", icon: "ri-flashlight-fill", desc: "当天最热一手信息，快速厘清全貌", color: "bg-primary-500" },
  { key: "analysis", name: "重点瓜分析", icon: "ri-scales-3-line", desc: "拆解节点，看清背后利益与逻辑", color: "bg-accent-500" },
  { key: "deep", name: "深度报道", icon: "ri-archive-drawer-line", desc: "多信源求证，还原时间线与人物", color: "bg-secondary-600" },
  { key: "cover", name: "封面故事", icon: "ri-book-open-line", desc: "每月封面专题，把大瓜讲成长文", color: "bg-foreground-800" },
  { key: "pick", name: "编辑推荐", icon: "ri-star-fill", desc: "编辑部甄选，值得反复回看", color: "bg-primary-600" },
];

export default function ColumnIntro() {
  const pickList = articles.filter((a) => a.category === "pick").slice(0, 2);
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="flex items-center justify-between">
          <div>
            <p className="section-kicker text-xs font-semibold text-accent-700">五大栏目体系</p>
            <h2 className="mt-2 font-serif text-2xl font-black text-foreground-950 md:text-3xl">
              栏目导航 · 各取所需
            </h2>
          </div>
          <p className="hidden text-sm text-foreground-600 lg:block">
            从秒懂到深读，总能找到适合你的那一档
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {colList.map((c, idx) => {
            const colArticles = articles.filter((a) => a.category === c.key);
            return (
              <Link
                key={c.key}
                to={`/#feed`}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("feed")?.scrollIntoView({ behavior: "smooth" });
                  window.dispatchEvent(new CustomEvent("guabao:column", { detail: c.key }));
                }}
                className="group flex flex-col rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-background-50"
              >
                <span className={`flex h-11 w-11 items-center justify-center rounded-lg ${c.color} text-background-50`}>
                  <i className={`${c.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-serif text-lg font-bold text-foreground-950">{c.name}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>共 {colArticles.length} 篇热稿</span>
                  <span className="flex items-center gap-1 text-primary-700">
                    去看看 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>

        {/* 编辑推荐横向条 */}
        <div className="mt-12 grid grid-cols-1 gap-4 rounded-xl bg-gradient-to-r from-secondary-800 to-foreground-800 p-6 md:grid-cols-[auto_1fr_auto] md:items-center md:gap-8 md:p-8">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-500 text-2xl text-background-50">
            <i className="ri-star-smile-fill" aria-hidden="true"></i>
          </span>
          <div>
            <h3 className="font-serif text-xl font-black text-background-50">本周编辑精选</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-background-100/85">
              编辑部从每日更新中甄选最值得一读的稿件，聚焦真正看懂门道的深度内容。
            </p>
          </div>
          <div className="flex flex-col gap-2">
            {pickList.map((p) => (
              <Link
                key={p.slug}
                to={`/article/${p.slug}`}
                className="group flex items-center gap-2 text-sm text-background-50 hover:text-background-200"
              >
                <i className="ri-corner-down-right-line text-accent-300" aria-hidden="true"></i>
                <span className="line-clamp-1">{p.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}